import { DataBean } from "../DataBean";

export class ProductionOrderTicket extends DataBean {



    public async getProductionOrderTicket(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderTicket_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }
    
}